import { render } from "./UserDialog.vue?vue&type=template&id=19bd8255&scoped=true"
import script from "./UserDialog.vue?vue&type=script&lang=js"
export * from "./UserDialog.vue?vue&type=script&lang=js"

import "./UserDialog.vue?vue&type=style&index=0&id=19bd8255&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19bd8255"]])

export default __exports__